import React from "react";
import { useTranslation } from "react-i18next";
import { observer } from "mobx-react-lite";
import { BuildingCertificationSettings } from "api-client";
import useCertificationsList from "../useCertificationsList";
import { FormValue, buildingSettingsStore } from "../BuildingSettingsStore";
import CertificationRow from "../components/CertificationRow";
import { useCertificationLicense } from "hooks/useCertificationLicense";

const LifeCycleAssessment = () => {
  const { t } = useTranslation();
  const { availableKeys, entitlementLoaded } = useCertificationLicense();

  const handleChange = (
    certification: keyof BuildingCertificationSettings,
    value: FormValue,
    name?: string
  ) => {
    if (!name) return;
    const updatedCertification = {
      ...buildingSettingsStore.settings[
        certification as keyof BuildingCertificationSettings
      ],
      [name]: value,
    };
    buildingSettingsStore.onChangeValue(updatedCertification, certification);
  };

  const { certifications } = useCertificationsList(handleChange);

  const onClickToggle = (state: boolean | undefined, id: string) => {
    handleChange(id as keyof BuildingCertificationSettings, state, "is_active");
  };

  return (
    <div>
      <div className="text-lg font-semibold mb-2">
        {t("buildingSettings.lifeCycleAssessmentForCertification")}
      </div>
      <div className="text-sm text-gray-700 pb-5">
        {t("buildingSettings.lifeCycleAssessmentDescription")}
      </div>
      {entitlementLoaded && availableKeys.length === 0 ? (
        <div className="text-sm text-gray-500 bg-gray-50 border border-gray-200 rounded-md p-4">
          {t("buildingSettings.noCertificationsInLicense")}
        </div>
      ) : (
        certifications.map((item) => (
          <CertificationRow
            item={item}
            key={item.id}
            onClickToggle={onClickToggle}
          />
        ))
      )}
    </div>
  );
};

export default observer(LifeCycleAssessment);
